'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getLinkName = getLinkName;
exports.bookingDocuments = bookingDocuments;
exports.externalDepartureDocuments = externalDepartureDocuments;
exports.externalDocuments = externalDocuments;
exports.externalDescriptions = externalDescriptions;

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import { endpoint } from '../../../config.js';

var wrc = window.winresCloud;

var WinresOmalomaBookingSummary = function () {
  function WinresOmalomaBookingSummary($rootScope, $scope, $sce, omalomaService, $filter, $q, cancelService) {
    _classCallCheck(this, WinresOmalomaBookingSummary);

    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$sce = $sce;
    this.omalomaService = omalomaService;
    this.$filter = $filter;
    this.$q = $q;
    this.cancelService = cancelService;

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // waiting_for_parameter - Waiting for a dynamic parameter to be set.
    // loading - Loading info.
    // ready - Info loaded.
    // error - Failed to load info.
    this.setStatus('init', null);

    // An error to be displayed. Passed to i18next.
    // Example error: Failed to fetch data from backend.
    this.$scope.error = null;

    this.$scope.bookingNumber = 0;
    this.$scope.total = 0;
    this.$scope.paid = 0;
    this.$scope.unpaid = 0;
    this.$scope.balance = 0;

    this.$scope.documents = [];

    this.$scope.schedule = null;
    this.$scope.scheduleInit = false;

    this.$scope.destinationName = null;
    this.$scope.beginDate = null;
    this.$scope.endDate = null;

    this.initTemplateFields();
  }

  _createClass(WinresOmalomaBookingSummary, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        return _this.setStatus('out', null);
      });
      this.$scope.$watch(function () {
        return _this.bookingNumber;
      }, function () {
        return _this.load();
      });
      if (this.omalomaService.isLoggedInAsCustomer()) {
        console.log("[WOBS] omalomaService.isLoggedInAsCustomer: ", this.omalomaService.isLoggedInAsCustomer());
        this.load();
      } else {
        this.setStatus('out', null);
      }

      this.$rootScope.$on('omaloma-refresh', function () {
        return _this.refresh();
      });
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      this.clear();
      if (!this.bookingNumber || !this.omalomaService.isLoggedInAsCustomer()) return;
      this.load();
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.$scope.error = null;
      this.$scope.bookingNumber = 0;
      this.$scope.total = 0;
      this.$scope.paid = 0;
      this.$scope.unpaid = 0;
      this.$scope.balance = 0;
      this.$scope.documents = [];
      this.$scope.schedule = null;
      this.$scope.scheduleInit = false;
      this.$scope.destinationName = null;
      this.$scope.beginDate = null;
      this.$scope.endDate = null;
      this.setStatus('out', null);
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      // Booking number is taken from bookings.
      // If no bookings, will wait indefinitely. no-bookings broadcast is called by winresOmaloaBookingPicker.js
      // which tells if there are no bookings.
      this.$scope.$on('no-bookings', function () {
        return _this2.setStatus("no_bookings", null);
      });
      if (!this.bookingNumber) {
        if (this.omalomaService.isLoggedInAsCustomer()) {
          console.log('[WOBS] Booking number not available yet.');
          this.setStatus('waiting_for_parameter', null);
          /*this.omalomaService.getBookingList().then(result => {
            if(result.length<=0) 
                this.setStatus("no_bookings", null);
          });*/
        }
        return;
      }

      this.setStatus('loading', null);

      this.loadHeaderInfo();
      this.loadBalance();
      this.loadBooking();
      this.getTravelSchedule();
      this.getPaymentDetails();
      //this.loadDestinationInfo();
      //this.loadDocumentInfo();
    }
  }, {
    key: 'getPaymentDetails',
    value: function getPaymentDetails() {
      var _this3 = this;

      this.omalomaService.getBookingBalance(this.bookingNumber).then(function (result) {
        _this3.$scope.total = result.Total;
        _this3.$scope.paid = result.Paid + result.Pending;
        _this3.$scope.unpaid = result.Unpaid;
      });
    }
  }, {
    key: 'loadDestinationInfo',
    value: function loadDestinationInfo() {
      var _this4 = this;

      this.omalomaService.getDestinationInfo(this.bookingNumber).then(function (info) {
        _this4.setStatus('ready', null);
      }).catch(function (error) {
        console.error('[WOBS] Failed to load booking:', error);
        _this4.setStatus('error', 'malfunction');
      });
    }
  }, {
    key: 'assignDepartureDocuments',
    value: function assignDepartureDocuments(documents) {
      this.$scope.documents = documents;
    }
  }, {
    key: 'loadBookingAndDepartureDocuments',
    value: function loadBookingAndDepartureDocuments(bookingNumber, departures) {
      var _this5 = this;

      this.$scope.documentSessionID = this.omalomaService.getSessionId();

      // Get requests.
      var departureRequests = _.map(departures, function (departure) {
        var destCode = departure.DestinationCode;
        var beginDate = departure.DepartureDate.split('T')[0];
        var endDate = departure.ArrivalDate2.split('T')[0];

        return {
          promise: _this5.omalomaService.getDepartureDocuments(destCode, beginDate, endDate),
          destCode: destCode,
          beginDate: beginDate,
          endDate: endDate
        };
      });

      var bookingRequest = {
        promise: this.omalomaService.getBookingFiles(bookingNumber)
      };

      var requests = _.concat([bookingRequest], departureRequests);

      var promises = _.map(requests, 'promise');

      // Get all booking documents and departure documents per departure.
      this.$q.all(promises).then(function (responses) {
        var bookingResponse = responses[0];
        var departureResponses = responses.slice(1);

        // Clear old documents.
        _this5.$scope.documents = [];

        var mappedDocuments = [];

        var bookingDocumentsExceptCustomerUploads = _.filter(bookingResponse, function (doc) {
          return doc.Type != 'CustomerUpload';
        });
        mappedDocuments = _.concat(mappedDocuments, bookingDocuments(_this5.$sce, bookingNumber, bookingDocumentsExceptCustomerUploads));

        _.each(departureResponses, function (response, idx) {
          var request = departureRequests[idx];
          var destCode = request.destCode;
          var beginDate = request.beginDate;
          var endDate = request.endDate;
          var documents = response;

          // Concat all documents.
          mappedDocuments = _.concat(mappedDocuments, externalDepartureDocuments(_this5.$sce, destCode, beginDate, endDate, documents));
        });

        _this5.assignDepartureDocuments(mappedDocuments);

        _this5.setStatus('ready', null);
      }).catch(function (error) {
        console.error('[WOBS] Failed to load booking files:', error);
        _this5.setStatus('error', 'malfunction');
      });
    }
  }, {
    key: 'loadHeaderInfo',
    value: function loadHeaderInfo() {
      var _this6 = this;

      this.omalomaService.getHeaderInfo(this.bookingNumber).then(function (info) {
        console.log('[WOBS] headerInfo  Got info: ', info);
        _this6.$scope.destinationName = info.Subtitle;
        _this6.$scope.beginDate = _this6.$filter('date')(info.BeginDate, "d.M.yyyy");
        _this6.$scope.endDate = _this6.$filter('date')(info.EndDate, "d.M.yyyy");
        _this6.setStatus('ready', null);
      }).catch(function (error) {
        console.error('[WOBS] Failed to get header info', _this6.bookingNumber, ':', error);
        _this6.setStatus('error', 'malfunction');
        _this6.reset();
      });
    }
  }, {
    key: 'loadBalance',
    value: function loadBalance() {
      var _this7 = this;

      this.omalomaService.getCustomerBookingBalance(this.bookingNumber).then(function (balance) {
        console.log('[WOBS] Got balance for', _this7.bookingNumber, ':', balance);
        _this7.$scope.balance = balance;
        _this7.setStatus('ready', null);
      }, function (error) {
        console.error('[WOBS] Failed to get balance for', _this7.bookingNumber, ':', error);
        _this7.setStatus('error', 'malfunction');
      });
    }
  }, {
    key: 'getTravelSchedule',
    value: function getTravelSchedule() {
      var _this8 = this;

      this.omalomaService.getSchedule(this.bookingNumber).then(function (schedule) {
        console.log("[WOBS] Got schedule for", _this8.bookingNumber, ": ", schedule);
        _this8.$scope.schedule = schedule;
        _this8.$scope.scheduleInit = true;
        //this.$scope.schedule[0][0].begin = moment(this.$scope.schedule[0][0].begin).format('d.M.YYYY [klo]  H.mm');
        _this8.setStatus('ready', null);
      }, function (error) {
        console.warn('[WOBS] Failed to get schedule for', _this8.bookingNumber, ':', error);
        _this8.$scope.scheduleInit = true;
        //this.setStatus('error', 'malfunction');
        // Seting status to ready so we can show the info even if no departures are found
        // this.setStatus('ready with no schedule', null);
      });
    }
  }, {
    key: 'loadBooking',
    value: function loadBooking() {
      var _this9 = this;

      this.omalomaService.getBooking(this.bookingNumber).then(function (booking) {
        console.log('[WOBS] Got booking info: ', booking);

        _this9.loadBookingAndDepartureDocuments(_this9.bookingNumber, booking.Departures);
      }, function (error) {
        console.error('[WOBS] Failed to get booking for', _this9.bookingNumber, ':', error);
      });
    }
  }, {
    key: 'initTemplateFields',
    value: function initTemplateFields() {
      this.$scope.destinationName = "Ladataan.. Nimi";
      this.$scope.beginDate = "Ladataan.. alkupvä";
      this.$scope.endDate = "Ladataan.. loppupvä";
      this.$scope.balance = "Ladataan.. Summa";
    }
  }, {
    key: 'setDestinationTemplateFields',
    value: function setDestinationTemplateFields(info) {
      console.log('[WOBS] Destination: "info: "', info);
      this.$scope.destinationName = info.DestinationName;
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, error) {
      this.$scope.status = status;
      console.log('[WOBS] Set status to', status);
      if (error !== undefined) {
        if (error) console.log('[WOBS] Error:', error);
        this.$scope.error = error;
      }
    }
  }, {
    key: 'goToPaymentTab',
    value: function goToPaymentTab() {
      //document.querySelectorAll("a[href='#tab-1493036671149-3-9']")[0].click();
      var tabID = angular.element('winres-omaloma-pay').closest('.tab-content').attr('id');
      console.log("[WOBS] Going to payments: TabID: ", tabID);
      // angular.element did not work here for some reason so document.querySelectorAll and added [0]
      document.querySelectorAll('a[href="#' + tabID + '"]')[0].click();
      //jQuery('a[href="#' +  jQuery('winres-omaloma-pay').closest('.tab-content').attr('id') +  '"]').click();
      console.log("[WOBS] Went to payments!");
    }
  }]);

  return WinresOmalomaBookingSummary;
}();

function getLinkName(url) {
  var str = "";
  var start = url.lastIndexOf("/");
  var last = url.slice(start + 1);
  if (last.lastIndexOf(".") > -1) {
    var end = last.lastIndexOf(".");
    str = last.slice(0, end); // dir1/dir2/test.jpg -> test
  } else str = url.split('#').shift().split('?').shift().split('/').pop();
  str = str.replace(/[_,-]/g, " "); // Remove _ and -.
  return str;
}

function bookingDocuments($sce, bookingNumber, documents) {
  return _.map(documents, function (document, i) {
    return {
      type: document.Type,
      number: i + 1,
      url: $sce.trustAsResourceUrl(wrc.endpoint + 'Filebank/Download/Bookings/' + bookingNumber + '/' + document.Type + 's/' + document.Name),
      text: getLinkName(document.Name),
      icon: 'file'
    };
  });
}

function externalDepartureDocuments($sce, destCode, beginDate, endDate, documents) {
  return _.map(documents, function (document, i) {
    return {
      type: document.Type,
      number: i + 1,
      // /Filebank/Download/Destinations/{DestinationCode}/Departures/{BeginDate}_{EndDate}/Documents/{Name}
      url: $sce.trustAsResourceUrl(wrc.endpoint + 'Filebank/Download/Destinations/' + destCode + '/Departures/' + beginDate + '_' + endDate + '/Documents/' + document.Name),
      text: getLinkName(document.Name),
      icon: 'file'
    };
  });
}

function externalDocuments(di) {
  return _.map(di.ExternalDocuments, function (url, i) {
    return {
      type: 'document',
      number: i + 1,
      icon: 'file',
      url: url,
      text: getLinkName(url)
    };
  });
}

function externalDescriptions(di) {
  if (di.ExternalUrl && di.ExternalUrl !== "") {
    return [{
      type: 'description',
      number: 1,
      url: di.ExternalUrl,
      icon: 'link',
      text: getLinkName(di.ExternalUrl)
    }];
  } else {
    return [];
  }
}

WinresOmalomaBookingSummary.$inject = ['$rootScope', '$scope', '$sce', 'omalomaService', '$filter', '$q', 'cancelService'];

_module3.default.component('winresOmalomaBookingSummary', {
  template: require('./winresOmalomaBookingSummary.html'),
  controller: WinresOmalomaBookingSummary,
  require: {},
  bindings: {
    bookingNumber: '<'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaBookingSummary/winresOmalomaBookingSummary.js
// module id = 331
// module chunks = 2